export default __webpack_public_path__ + "static/media/profile.faf2d666.png";